import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Sparkles, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Pop-up pour inviter les utilisateurs à ajouter leurs compétences
 */
const CompetencesPrompt = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;

    // Vérifier si l'utilisateur a déjà vu la pop-up
    const hasSeenPrompt = localStorage.getItem(`competences-prompt-${user.id}`);
    
    // Vérifier si l'utilisateur a des compétences
    const hasCompetences = user.competences && user.competences.length > 0;

    // Afficher la pop-up si :
    // - Il n'a pas vu la pop-up
    // - Il n'a pas de compétences
    if (!hasSeenPrompt && !hasCompetences) {
      // Attendre 2 secondes après le chargement
      const timer = setTimeout(() => {
        setOpen(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [user]);

  const handleAddCompetences = () => {
    setOpen(false);
    navigate('/profil');
  };

  const handleIgnore = () => {
    setOpen(false);
    // Enregistrer que l'utilisateur a vu la pop-up
    if (user) {
      localStorage.setItem(`competences-prompt-${user.id}`, 'seen');
    }
  };

  if (!user) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Sparkles className="w-6 h-6 text-purple-600" />
              <DialogTitle className="text-xl">
                Complétez votre profil ! 🎯
              </DialogTitle>
            </div>
          </div>
          <DialogDescription className="text-base pt-2">
            Bienvenue sur Alliance Solidarité ! 
            <br /><br />
            <strong>Ajoutez vos compétences</strong> pour que la communauté sache dans quels domaines vous pouvez aider.
            <br /><br />
            📚 Éducation • 🔧 Bricolage • 🌿 Jardinage • 🏠 Hébergement • Et bien plus !
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-2 pt-4">
          <Button
            onClick={handleAddCompetences}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700"
          >
            <Sparkles className="w-4 h-4 mr-2" />
            Ajouter mes compétences
          </Button>
          
          <Button
            variant="outline"
            onClick={handleIgnore}
            className="w-full"
          >
            Plus tard
          </Button>
          
          <p className="text-xs text-gray-500 text-center pt-2">
            Vous pouvez toujours ajouter vos compétences depuis votre profil
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CompetencesPrompt;
